import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${props => props.theme.spacing.sp16};
`
